import React from "react";
import { FormattedMessage } from "react-intl";

import { Banner, Button, HStack, Stack, Text } from "@/components/ui";
import { useAuth } from "@/contexts/auth/useAuth";
import { useModalContext } from "@/contexts/modal-context";
import { useRegistrationStatus } from "@/hooks";
import { config } from "@/utils/config";

const CtaBanner = () => {
  const { isOpen } = useRegistrationStatus();
  const displayCta = config.displayCta;
  const { currentAccount } = useAuth();
  const { openModal } = useModalContext();

  const handleOpenRegistration = () =>
    openModal("REGISTRATION", { useCurrentUrlForRedirect: true });
  const handleOpenSignIn = () =>
    openModal("SIGNIN", { useCurrentUrlForRedirect: true });

  if (currentAccount || !displayCta || !isOpen) return null;

  return (
    <div data-testid="cta-banner" className="hidden lg:block">
      <Banner theme="default">
        <HStack alignItems="center" justifyContent="between">
          <Stack>
            <Text size="2xl" weight="bold">
              <FormattedMessage
                id="cta_banner.unauthed.title"
                defaultMessage="Continue the conversation"
              />
            </Text>

            <Text weight="medium" theme="muted">
              <FormattedMessage
                id="cta_banner.unauthed.subtitle"
                defaultMessage="Sign up now to create your personalized experience."
              />
            </Text>
          </Stack>

          <HStack space={2} alignItems="center">
            <Button variant="default" onClick={handleOpenRegistration}>
              <FormattedMessage
                id="account.register"
                defaultMessage="Create Account"
              />
            </Button>

            <Button variant="outline" onClick={handleOpenSignIn}>
              <FormattedMessage id="account.login" defaultMessage="Sign In" />
            </Button>
          </HStack>
        </HStack>
      </Banner>
    </div>
  );
};

export default CtaBanner;
